// assets/shoefinder-score.js
// Module pur, importable côté Node (ESM) et chargé tel quel par shoefinder.js (window.ShoefinderScore).
// Contrat candidat : { handle, id, genre, shoefinder: {terrain,niveau,amorti,usage,trail_terrain?,plaque?,categorie?}, drop, poids }
const NIVEAU = ["debutant", "regulier", "confirme"];
const AMORTI = ["max", "equilibre", "dynamique"];
const USAGE  = ["footing", "longue", "competition"];

function ordScore(order, a, b, exact, near) {
  const i = order.indexOf(a), j = order.indexOf(b);
  if (i < 0 || j < 0) return 0;
  const d = Math.abs(i - j);
  return d === 0 ? exact : d === 1 ? near : 0;
}

// Drop attendu selon l'amorti choisi (heuristique : amorti max => drop plus haut)
function dropBonus(amorti, drop) {
  if (drop == null || isNaN(drop)) return 0;
  const band = { max: [6, 12], equilibre: [4, 10], dynamique: [0, 8] }[amorti];
  if (!band) return 0;
  return drop >= band[0] && drop <= band[1] ? 1 : 0;
}

function scoreOne(profile, c) {
  const f = c.shoefinder || {};
  let s = 0;
  s += ordScore(NIVEAU, profile.niveau, f.niveau, 3, 1);
  s += ordScore(AMORTI, profile.amorti, f.amorti, 3, 1);
  s += ordScore(USAGE,  profile.usage,  f.usage,  2, 1);
  s += dropBonus(profile.amorti, Number(c.drop));
  if (profile.terrain === "trail" && profile.trail_terrain && f.trail_terrain === profile.trail_terrain) s += 2;
  if (profile.usage === "competition" && f.plaque === "carbone") s += 1;
  if (profile.niveau === "confirme" && f.categorie === "performance") s += 1;
  if (profile.niveau === "debutant" && f.categorie === "initiation") s += 1;
  return s;
}

export function selectTop(profile, candidates, max = 8) {
  // Filtres durs : genre + terrain. (trail_terrain reste un bonus, cf. plan §Task 3.)
  const pool = candidates.filter(c =>
    (!profile.genre || c.genre === profile.genre) &&
    (!profile.terrain || (c.shoefinder || {}).terrain === profile.terrain));
  const scored = pool
    .map((c, idx) => ({ c, idx, s: scoreOne(profile, c) }))
    .sort((a, b) => (b.s - a.s) || (a.idx - b.idx)); // tri stable, score desc
  return scored.slice(0, max).map(x => ({ ...x.c, score: x.s }));
}

// Exposition navigateur (le fichier est chargé en <script type="module"> sur le storefront).
if (typeof window !== "undefined") { window.ShoefinderScore = { selectTop }; }
